module.exports = "./logo.93aef50.png";